import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import Toggle from '../../../Common/Toggle/Toggle';


export const WelcomeMessageSection = (props) => {

    let toolbar = {
        options: ['inline', 'fontSize', 'fontFamily', 'textAlign', 'colorPicker', 'link', 'emoji'],
        inline: {
            options: ['bold', 'italic', 'underline']
        }
    };

    const onActiveChange = (name, isChecked) => {
        props.onFormChange(name, isChecked);
    }

        const className = props.isFormValid ? "welcome-message-form" : "welcome-message-form was-validated"
    return (
        <div className="welcome-message-section section">
            <form className={className} noValidate>
                <div className="row content">
                    <div className="col-12 col-md-4 header">
                        <h4>Welcome Message</h4>
                        <p>You can have a customized message display when your colleagues login to Pacer. This is helpful when you need to broadcast a message to all users.</p>
                    </div>
                    <div className="col-12 col-md-8 fields">
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <Toggle name="isWelcomeMessageActive" text="Welcome Message Active" checked={props.subscription.isWelcomeMessageActive} onChange={onActiveChange} />
                            </div>
                            <div className="col-12 col-lg-6">
                                {props.subscription.isWelcomeMessageActive &&
                                    <Toggle name="isWelcomeMessageConstant" text="Display Welcome Message Every Login" checked={props.subscription.isWelcomeMessageConstant} onChange={onActiveChange} />
                                }
                            </div>
                        </div>
                        <div className="row mt-3">
                            <strong>Welcome Message</strong>
                        </div>
                        <div className="row pb-3">
                            <Editor
                                spellCheck={true}
                                toolbarClassName="toolbarClassName"
                                wrapperClassName="wrapperClassName"
                                editorClassName="editorClassName"
                                toolbar={toolbar}
                                onEditorStateChange={props.onWelcomeMessageChange}
                                editorState={props.editorState}
                            />
                        </div>
                        <div className="row my-3">
                            {props.showWelcomeMessageRequired && !props.isFormValid &&
                                <div className="text-danger">Welcome Message is required if this setting is set to Active.</div>
                            }
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

WelcomeMessageSection.propTypes = {
    subscription: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired,
    showWelcomeMessageRequired: PropTypes.bool.isRequired,
    onWelcomeMessageChange: PropTypes.func.isRequired,
    editorState: PropTypes.object
};


export default WelcomeMessageSection;

